export default __webpack_public_path__ + "static/media/trr-drink-default.f757b4cf.png";